import { useMemo } from "react";
import TabContainer, { TabConfig } from "../../../components/TabContainer";
import AutomationTab from "./AutomationTab";
import InterstitialNotificationsTab from "./automation/interstitial-notifications/InterstitialNotificationsTab";

const automationConfig: TabConfig[] = [
  {
    title: "Push Notifications",
    pathname: "push-notifications",
    element(brandID) {
      return <AutomationTab brandID={brandID} key={brandID} />;
    },
  },
  {
    title: "Interstitial Notifications",
    pathname: "interstitial-notifications",
    element(brandID) {
      return <InterstitialNotificationsTab brandID={brandID} key={brandID} />;
    },
  },
];

const AutomationTabContainer = ({
  brandID,
  areInterstitialNotificationsEnabled,
}: {
  brandID: string;
  areInterstitialNotificationsEnabled: boolean;
}) => {
  const tabs = useMemo(() => {
    if (areInterstitialNotificationsEnabled) {
      return automationConfig;
    }
    return automationConfig.filter(
      (config) => config.pathname !== "interstitial-notifications"
    );
  }, [areInterstitialNotificationsEnabled]);

  return <TabContainer brandID={brandID} tabs={tabs} />;
};

export default AutomationTabContainer;
